import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'

import { getAppLayout } from '../../utils'
import { selectRouterLocation } from '../../redux/selectors'
import getWebsiteUrlWithParams from '../../utils/getWebsiteUrlWithParams'

const { hostname } = window.location
const layout = getAppLayout(hostname)

const StyledRootDiv = styled('div')(({ theme }) => ({
  display: 'block',
  padding: theme.spaces.default / 2,
}))

const StyledRootAnchor = styled('a')(({ theme }) => ({
  display: 'block',
  padding: theme.spaces.default / 2,
}))

const StyledImg = styled('img')({
  maxWidth: '100%',
  width: '100%',
  height: 'auto',
  display: 'block',
})

const MainHeaderLogo = ({
  src, srcset, alt, onClick, logoRef,
}) => {
  const { search } = useSelector(selectRouterLocation)
  const href = getWebsiteUrlWithParams({ search })

  const logo = <StyledImg src={src} srcSet={srcset} alt={alt} />

  if (layout.blockWebsiteRedirect) {
    return (
      <StyledRootDiv>
        {logo}
      </StyledRootDiv>
    )
  }

  return (
    <StyledRootAnchor
      ref={logoRef}
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={onClick}
    >
      {logo}
    </StyledRootAnchor>
  )
}

MainHeaderLogo.propTypes = {
  logoRef: PropTypes.shape({}),
  src: PropTypes.string.isRequired,
  srcset: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

MainHeaderLogo.defaultProps = {
  onClick: () => null,
  logoRef: null,
}

export default MainHeaderLogo
